<template>
	<AppDropzone
		class="menu-upload-dropzone"
		:class="{disabled}"
		is-ai
		v-if="!funnelStore.pollingMenuUpload"
		:max-bytes="5 * 1000 * 1024"
		:max-width="5000"
		:max-height="5000"
		:allow-pdf="true"
		@uploading="loadGeneratingAnimation"
		@upload-complete="menuFileUploadComplete"
	/>
	<div v-show="funnelStore.pollingMenuUpload" id="ai-funnel-menu-generation-anim"></div>
</template>

<script>
import { useLanguageStore, useSvgStore, useNotificationStore } from "@/shared/stores";
import { useUserStore, useMenuStore, useFunnelStore } from "@/console-new/stores";
import AppPopup from "@/shared/components/AppPopup.vue";
import API from "@/shared/helpers/API";
import AppLoader from "@/shared/components/AppLoader.vue";
import AppDropzone from "@/shared/components/AppDropzone.vue";

export default {
	setup() {
		const userStore = useUserStore();
		const languageStore = useLanguageStore();
		const svgStore = useSvgStore();
		const notificationStore = useNotificationStore();
		const menuStore = useMenuStore();
		const funnelStore = useFunnelStore();
		return { userStore, menuStore, getIcon: svgStore.get, funnelStore, showNotification: notificationStore.showNotification, getString: languageStore.getString };
	},
	name: "StepsBottomSheetAIUpload",
	emits: ["upload-complete"],
	components: {AppDropzone, AppPopup, AppLoader},
	props: {
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			registryPages: [
				{id: 'ai', slotName: 'ai-add-menu'},
				{id: 'manual', slotName: 'manual-add-menu'},
			],
		}
	},
	computed: {

	},
	methods: {
		menuFileUploadComplete(urls){
			this.$emit("upload-complete", urls);
		},
		loadGeneratingAnimation() {
			if(typeof bodymovin !== 'undefined') {
				const animationPath = 'https://img.qromo.io/img/vue/anim/ai-generation' + (this.userStore.darkMode ? '-dark' : '-light') + '.json';
				if(!this.loadedAnimation) {
					this.generationAnimation = bodymovin.loadAnimation({
						container: document.getElementById('ai-funnel-menu-generation-anim'),
						renderer: 'svg',
						loop: true,
						autoplay: true,
						path: animationPath,
						rendererSettings: {
							preserveAspectRatio: 'xMidYMid meet'
						}
					});
					this.loadedAnimation = true;
				}
			}
		}
	},
	mounted() {
		if(this.funnelStore.pollingMenuUpload) {
			this.loadGeneratingAnimation();
		}
	},
	beforeUnmount() {
		if(this.generationAnimation) {
			this.generationAnimation.destroy();
		}
	},
	watch: {
		"funnelStore.pollingMenuUpload"(newValue) {
			if(newValue) {
				this.loadGeneratingAnimation();
			}
		}
	},
}
</script>

<style lang="scss" scoped>
.menu-upload-dropzone.dropzone-container {
	width: 280px;
	height: 100%;
	min-height: 240px;
	padding-bottom: 2px;

	@media (max-width: 320px) {
		width: 100%;
	}

	:deep(.dropzone-wrapper) {
		height: 100%;
		.dropzone {
			width: 100%;
			height: 100%;
		}
	}
}
@media (max-width: 768px) {
	.menu-upload-dropzone.dropzone-container {
		width: 100%;
		height: 150px;
		min-height: unset;
	}
}
</style>